import { gql } from '@apollo/client';

export default gql`
  mutation updateAdditionalDetails($bookingReference: String!, $additionalDetails: [InputAdditionalDetails]!) {
    updateAdditionalDetails(bookingReference: $bookingReference, additionalDetails: $additionalDetails) {
      reference
    }
  }
`;
